<template>
  <div class="card border-0 bg-primary text-white">
    <div class="card-body">
      <div class="d-flex flex-wrap align-items-center">
        <i class="fe fe-server font-size-50 mr-3" />
        <div>
          <div class="font-size-21 font-weight-bold">Data Menunggu SP2D</div>
          <div class="font-size-15">Total: 6 Dinas, Nominal: 11M</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'KitGeneral21v1',
}
</script>
